import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import FunctionGeneral from '../../functionsGeneral';
import ContractsService from '../../../../../services/ContractsService';
import Globals from '../../../../../Globals';
import Loading from '../../../../bronson/Loading';

const DistribucionAsignacionJJVV = props => {
    const [maxPag, setMaxPag] = useState(0);
    const [li_Pag, setli_Pag] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setrowsPerPage] = useState(15);
    const [rows, setrows] = useState([]);
    const [dataConcesionario, setdataConcesionario] = useState([]);
    const [loaded, setloaded] = useState(false);
    useEffect(() => {
        detalleConcesionario(props.DealerCodeVWFS);
    }, [props.DealerCodeVWFS]);

    useEffect(() => {
        var rowstable = [];
        var row = [];
        dataConcesionario.forEach(element => {
            if (row.length === 0) row.push(element);
            else if (row[0].IDVENDEDORASIGNADO === element.IDVENDEDORASIGNADO)
                row.push(element);
            else {
                let rowTable = [];
                rowTable.CONCECIONNOMBRE =
                    row[0].VENDEDORASIGNADO !== null
                        ? new FunctionGeneral().capitalizeText(
                              row[0].VENDEDORASIGNADO.split(' ')
                          )
                        : '';
                rowTable.POCIDCANALVWF = row[0].IDVENDEDORASIGNADO;
                rowTable.PREASIGNADO = 0;
                rowTable.NOPREASIGNADO = 0;
                rowTable.HUERFANO = 0;
                rowTable.AUTOASIGNADO = 0;
                row.forEach(elementRow => {
                    if (elementRow.PREASIGNADO === 'S')
                        rowTable.PREASIGNADO = elementRow.TOTALCONTRATOS;
                    else if (elementRow.PREASIGNADO === 'A')
                        rowTable.AUTOASIGNADO = elementRow.TOTALCONTRATOS;
                    else if (elementRow.PREASIGNADO === 'N')
                        rowTable.NOPREASIGNADO = elementRow.TOTALCONTRATOS;
                    else rowTable.HUERFANO = elementRow.TOTALCONTRATOS;
                });
                rowstable.push(rowTable);
                row = [];
                row.push(element);
            }
        });
        if (row.length > 0) {
            let rowTable = [];
            rowTable.CONCECIONNOMBRE = row[0].VENDEDORASIGNADO;
            rowTable.POCIDCANALVWF = row[0].IDVENDEDORASIGNADO;
            rowTable.PREASIGNADO = 0;
            rowTable.NOPREASIGNADO = 0;
            rowTable.HUERFANO = 0;
            rowTable.AUTOASIGNADO = 0;
            row.forEach(elementRow => {
                if (elementRow.PREASIGNADO === 'S')
                    rowTable.PREASIGNADO = elementRow.TOTALCONTRATOS;
                else if (elementRow.PREASIGNADO === 'N')
                    rowTable.NOPREASIGNADO = elementRow.TOTALCONTRATOS;
                else if (elementRow.PREASIGNADO === 'A')
                    rowTable.AUTOASIGNADO = elementRow.TOTALCONTRATOS;
                else rowTable.HUERFANO = elementRow.TOTALCONTRATOS;
            });
            rowstable.push(rowTable);
        }

        setrows(rowstable);
    }, [dataConcesionario]);
    useEffect(() => {
        setMaxPag(
            parseInt(rows.length / rowsPerPage) +
                (rows.length % rowsPerPage === 0 ? -1 : 0)
        );
    }, [rows, rowsPerPage]);

    useEffect(() => {
        var new_li = [];
        var positioncalco = 0;
        if (page === 1) positioncalco = 1;
        else if (page === 0) positioncalco = 0;
        else if (page === maxPag) positioncalco = 4;
        else if (page + 1 === maxPag) positioncalco = 3;
        else if (page >= 2) positioncalco = 2;

        for (
            let i = page - positioncalco;
            new_li.length < 5 && page - positioncalco + new_li.length <= maxPag;
            i++
        ) {
            if (i >= 0) {
                if (i === page)
                    new_li.push(
                        <li className="c-pagination__item" key={'item_' + i}>
                            <span
                                aria-current="page"
                                className="c-pagination__link  is-active"
                                onClick={() => handleChangePage(i)}
                            >
                                {i + 1}
                            </span>
                        </li>
                    );
                else
                    new_li.push(
                        <li className="c-pagination__item" key={'item_' + i}>
                            <span
                                aria-current="page"
                                className="c-pagination__link"
                                onClick={() => handleChangePage(i)}
                            >
                                {i + 1}
                            </span>
                        </li>
                    );
            } else new_li.push(<span key="-----"></span>);
        }
        setli_Pag(new_li);
    }, [page, maxPag, rows]);

    const handleChangePage = newPage => {
        if (newPage >= 0 && newPage <= maxPag) setPage(newPage);
    };
    const handleChangeRowsPerPage = event => {
        setrowsPerPage(+event.target.value);
        setPage(0);
    };
    function detalleConcesionario(params) {
        ReadAsignacionVolumenVendedorToMetricasToConcesionarios(params);
    }

    async function ReadAsignacionVolumenVendedorToMetricasToConcesionarios(
        DealerCodeVWFS
    ) {
        setloaded(true);
        var _response =
            await new ContractsService().ReadAsignacionVolumenVendedorToMetricasToConcesionarios(
                props.cookies.get(Globals.COOKIES.JWT).AccessToken,
                DealerCodeVWFS
            );
        if (
            _response &&
            _response.statusCode === 200 &&
            _response.body &&
            _response.body.Result
        ) {
            var response = JSON.parse(_response.body.Result);
            setdataConcesionario(response);
            setloaded(false);
        } else setloaded(false);
    }
    const displayTableConcesionariosDetalle = () => {
        var total = 0,
            totalPreAsignados = 0,
            totalNoPreAsignados = 0,
            totalHuerfanos = 0,
            totalautoAsignados = 0;
        rows.forEach(element => {
            totalPreAsignados += element.PREASIGNADO;
            totalNoPreAsignados += element.NOPREASIGNADO;
            totalHuerfanos += element.HUERFANO;
            totalautoAsignados += element.AUTOASIGNADO;
        });
        return (
            <div className="u-1/1 c-table-wrapper c-table--wide tablaVencimientos">
                <table>
                    <thead>
                        <tr>
                            <th scope="col">Vendedor Asignado</th>

                            <th scope="col">
                                Pre Asignados({totalPreAsignados})
                            </th>
                            <th scope="col">
                                Asignados JJVV({totalNoPreAsignados})
                            </th>
                            <th scope="col">
                                AutoAsignados V({totalautoAsignados})
                            </th>
                            <th scope="col">
                                Total(
                                {totalPreAsignados +
                                    totalNoPreAsignados +
                                    totalHuerfanos +
                                    totalautoAsignados}
                                )
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows
                            .slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                            )
                            .map(rowTable => (
                                <tr
                                    id={rowTable.POCIDCANALVWF}
                                    key={rowTable.POCIDCANALVWF}
                                >
                                    <td>
                                        {rowTable.CONCECIONNOMBRE !== ''
                                            ? rowTable.CONCECIONNOMBRE
                                            : 'No asignados'}
                                    </td>
                                    <td>{rowTable.PREASIGNADO}</td>
                                    <td>{rowTable.NOPREASIGNADO}</td>
                                    <td>{rowTable.AUTOASIGNADO}</td>
                                    <td>
                                        {rowTable.HUERFANO +
                                            rowTable.NOPREASIGNADO +
                                            rowTable.PREASIGNADO +
                                            rowTable.AUTOASIGNADO}
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
        );
    };
    const pagination = () => {
        return (
            <section className="u-1/1">
                <div className="o-layout__item u-9/12 u-12/12@s">
                    <nav
                        className="c-pagination tablaVencimientos"
                        aria-label="Pagination"
                    >
                        <ul className="c-pagination__list">
                            <li className="c-pagination__item">
                                <a
                                    onClick={() => handleChangePage(page - 1)}
                                    className={
                                        (props.page > 0 ? '' : 'is-disabled') +
                                        ' c-pagination__link  c-pagination__link--stepper-prev'
                                    }
                                    style={{
                                        display: 'flex',
                                        position: 'inherit',
                                    }}
                                    title="prev page"
                                ></a>
                            </li>
                            {li_Pag}
                            <li className="c-pagination__item">
                                <a
                                    onClick={() => handleChangePage(page + 1)}
                                    className={
                                        (page + 1 <= maxPag
                                            ? ''
                                            : 'is-disabled') +
                                        'c-pagination__link  c-pagination__link--stepper-next'
                                    }
                                    style={{ display: 'flex' }}
                                    title="next page"
                                >
                                    <span className="u-visually-hidden">
                                        next page
                                    </span>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div
                    className="o-layout__item u-3/12 u-12/12@s c-form-field__box u-text-right"
                    style={{ marginTop: '16px' }}
                >
                    <span
                        style={{ verticalAlign: 'middle', marginRight: '10px' }}
                        className="u-text-brand"
                    >
                        Concesionario por página
                    </span>
                    <div
                        className="c-input c-input--select"
                        style={{ width: 'fit-content', float: 'right' }}
                    >
                        <select
                            className="c-input__input"
                            onChange={handleChangeRowsPerPage}
                            defaultValue={rowsPerPage}
                        >
                            <option>15</option>
                            <option>30</option>
                            <option>50</option>
                            <option>100</option>
                            <option>1000</option>
                        </select>
                    </div>
                </div>
            </section>
        );
    };
    const displayConcesionarioDetalle = () => {
        var CONCECIONNOMBRE = '';
        var POCIDCANALVWF = '';
        if (dataConcesionario.length > 0) {
            CONCECIONNOMBRE = dataConcesionario[0].CONCECIONNOMBRE;
            POCIDCANALVWF = dataConcesionario[0].POCIDCANALVWF;
        }
        return (
            <div className="u-pb-small u-rema-full-height">
                <Loading ariaBusy={loaded}></Loading>
                <section className="o-content-section">
                    <div className="o-component-wrapper u-hide@s">
                        <h3 className="u-text-center">
                            <div
                                className="iconHover"
                                style={{ display: 'contents' }}
                            >
                                Distribución de contratros a asesor(
                                {CONCECIONNOMBRE} {POCIDCANALVWF})
                            </div>
                        </h3>
                    </div>
                    <section className="u-1/1">
                        {displayTableConcesionariosDetalle()}
                        {pagination()}
                    </section>
                </section>
            </div>
        );
    };
    return (
        <React.Fragment>
            <div>{displayConcesionarioDetalle()}</div>
        </React.Fragment>
    );
};
export default withRouter(DistribucionAsignacionJJVV);
